import { Box, Text } from "@primer/react";
import { CheckIcon } from "@primer/octicons-react";

interface ToastProps {
  message: string;
}

export function Toast({ message }: ToastProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 100,
        backgroundColor: "#1d1d1f",
        color: "white",
        padding: "12px 16px",
        borderRadius: "10px",
        boxShadow: "0 12px 30px rgba(0, 0, 0, 0.14)",
        display: "flex",
        alignItems: "center",
        gap: 2,
        animation: "slideIn 0.2s ease-out",
      }}
      data-oid="nuro6fk"
    >
      <CheckIcon data-oid="blnw1wp" />
      <Text sx={{ color: "white" }} data-oid="jh7v95a">
        {message}
      </Text>
    </Box>
  );
}
